module.exports = __webpack_public_path__ + "img/barcelo-resort-2.a8d155d1.jpg";